import React from 'react';
import { Provider } from 'react-redux';
import store from './redux/store';
import { Route, Router, Switch } from 'react-router-dom';
import Views from './views';
import { QueryClientProvider } from 'react-query';
import { history } from './broserHistory';
import { queryClient } from './queryClient';
import withFeatureFlagsProvider from './integration/featureflags';

function App() {
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <Router history={history}>
            <Switch>
              <Route path="/" component={Views} />
            </Switch>
          </Router>
        </Provider>
      </QueryClientProvider>
    </div>
  );
}

export default withFeatureFlagsProvider(App);
